import _classCallCheck from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js";
import _createClass from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/createClass.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
import Config from "../config";
import Http from 'axios';
var User = /*#__PURE__*/function () {
  function User() {
    _classCallCheck(this, User);
    // this.config.origin = Env('BASE_URL')
    this.config.origin = Config('api.api_url');
    this.config.endpoint = '/users/';
  }
  return _createClass(User, null, [{
    key: "currentUser",
    value: function currentUser() {
      var response = Http.get(Config('api.current_user_url'));
      return new Promise(function (resolve, reject) {
        response.then(function (user) {
          return resolve(user.data);
        }).catch(function (error) {
          return reject(error);
        });
      });
    }
  }]);
}();
export default User;